import { Component, OnInit } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-degree-type',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './add-degree-type.component.html',
  styleUrls: ['./add-degree-type.component.scss'],
})
export class AddDegreeTypeComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  degreeType: any;
  degreeTypeData: any;

  showAdd = false;
  showEdit = false;
  id: any;

  degreeTypeForm: UntypedFormGroup;

  showErr = false;

  searchval: any;

  error_messages = {
    degreeTypeName: [{ type: 'required', message: 'Please enter degree type' }],
  };
  deleteErr: any;
  adminName: any;
  adminImage: any;
  allDegreeType: any;
  allData: any;

  showData = false;
  showNodata = false;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.degreeTypeForm = this.formBuilder.group({
      degreeTypeName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.degreeTypeForm.reset();
    const servicePath = this.utils.getApiConfigs('degreetype');
    console.log('servicePath', servicePath);
    this.commonservice
      .invokeService(servicePath[1].method, servicePath[1].path, '')
      .then((resp: any) => {
        // console.log("District", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.degreeTypeData = resp.data;

          if (this.degreeTypeData == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.allDegreeType = this.degreeTypeData;
      });
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.degreeTypeData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allDegreeType = this.allData.filter((item) =>
        item.type.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allDegreeType);
    if (this.allDegreeType == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  openAdd() {
    this.degreeTypeForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  editDegreeType(data) {
    // console.log("Data", data);
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.degreeType = data.type;
    this.id = data.id;
  }

  deleteDegreeType(data) {
    // console.log("Data", data);
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  addDegreeType() {
    this.spinner.show();
    let payload = {
      degree_type: this.degreeType,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('degreetype');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Degree type added successfully');
          this.display = 'none';
          this.degreeTypeForm.reset();
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
        }
      });
  }

  updateDegreeType() {
    this.spinner.show();
    let payload = {
      degree_type: this.degreeType,
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('degreetype');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Degree type updated successfully');
          this.display = 'none';
          this.ngOnInit();
          this.degreeTypeForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletedegreetype');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Degree type deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.deleteErr = resp.message;
          this.showErr = true;
        }
      });
  }
}
